import { TaxBatchItem } from "@redux/modules/tax-batchs/interface";
import { DataStructure } from "@redux/plugins/data-fetcher/interface";
import { PaginationState } from "@redux/plugins/pagination-manager/interface";

export type TaxBatch = TaxBatchItem;

export interface TaxBatchMovement {
    id: number;
    orderId: number | null;
    skuTaxBatchId: number;
    typeTaxBatchMovementId: number;
    userId: number | null;
    description: string | null;
    quantity: number;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
}

export interface PaginationParams {
    skuTaxBatchId: string;
    limit?: number;
    page?: number;
}

export type State = {
    integrations: DataStructure<TaxBatch, null>;
    movements: PaginationState<TaxBatchMovement, Record<string, never>>;
};

export const moduleId = "taxBatch" as const;
